module.exports = __webpack_public_path__ + "img/gt.60660276.svg";